import { useDispatch, useSelector } from "react-redux";
import QzTraySignerService from "../../services/qztray/QzTraySignerService";
import {
  setLoading,
  setError,
  setSignatureResult,
  setPayload,
  setPayloadPretty,
  setCertificateType,
} from "../../store/slices/qztray/qzTraySignerSlice";
import { RootState } from "../../store/store";
import useApiErrorHandler from "../useApiErrorHandler";

export const useQzTraySigner = () => {
  const dispatch = useDispatch();
  const signerState = useSelector((state: RootState) => state.qzTraySigner);
  const { handle } = useApiErrorHandler();

  // ================================================================
  // ✍️ FIRMAR PAYLOAD
  // ================================================================
  const handleSign = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await QzTraySignerService.signPayload(
        signerState.payload,
        signerState.certificateType
      );

      if (!response?.data) {
        throw new Error("Respuesta inválida del servidor");
      }

      console.log(response)

      const { payload, payloadPretty, signature, fileName, signedAt } = response.data;

      // ✅ Guardar todo el resultado
      dispatch(
        setSignatureResult({
          payload,
          payloadPretty,
          signature,
          fileName,
          signedAt,
        })
      );

      return response.data;
    } catch (err: any) {
      handle(err);
      dispatch(setError(err?.response?.data?.message || "Error al firmar"));
    } finally {
      dispatch(setLoading(false));
    }
  };

  // ================================================================
  // ✅ VERIFICAR FIRMA DIGITAL
  // ================================================================
  const handleVerify = async (
    payload: string,
    signature: string,
    certificateType: string
  ) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await QzTraySignerService.verifySignature(
        payload,
        signature,
        certificateType
      );

      const { statusCode, type, message, data } = response;

      if (statusCode === 200 && type === "success") {
        console.log("✅ Verificación exitosa:", data);
        return { valid: true, ...data };
      }

      dispatch(setError(message || "Error al verificar la firma."));
      return { valid: false };
    } catch (err: any) {
      handle(err);
      dispatch(setError("Error al verificar la firma."));
      return { valid: false };
    } finally {
      dispatch(setLoading(false));
    }
  };
  

  // ================================================================
  // 🔁 Retorno del hook
  // ================================================================
  return {
    ...signerState,
    handleSign,
    handleVerify,
    setPayload: (value: string) => dispatch(setPayload(value)),
    setPayloadPretty: (value: string) => dispatch(setPayloadPretty(value)),
    setCertificateType: (value: string) => dispatch(setCertificateType(value)),
  };
};
